import * as React from "react";
// import DigitalCheckOutPage from "../../src/Digital/CheckOut/DigitalCheckOutPage";

import dynamic from "next/dynamic";
import { GetStaticProps } from "next";
import { fetchStoryContent } from "functions/src/shared/Digital/Storyblok/fetchStory";
import { CheckoutTranslateStoryblok } from "functions/src/shared/Digital/StoryBlockSchema/components-schema";
import { TranslateProvider } from "../../src/i18n/useStoryblokTranslate";
import Head from "next/head";
import { fetchTranslates } from "../../lib/Storyblok/fetchTranslation";
import { SimpleContainer } from "../../src/Basic/SimpleContainer";
import { PageContainer } from "../../src/Basic/PageContainer";
import CheckOutSuccessSection from "../../src/Digital/CheckOut/CheckoutForm/CheckOutSuccessSection";
import TranslateWrapper from "../../src/i18n/TranslateWrapper";
import AuthCheckRedirect from "../../src/Utility/Route/AuthCheckRedirect";
import CheckOutErrorMessage from "../../src/Digital/CheckOut/CheckoutForm/CheckOutErrorMessage";
import { useCurrentTrade } from "../../src/Digital/CheckOut/CheckoutForm/useCurrentTrade";
import CheckOutFailSection from "../../src/Digital/CheckOut/CheckoutForm/CheckOutFailSection";
import { useTranslation } from "react-i18next";
import { Typography, Divider } from "@mui/material";
import MajorButton from "../../src/Utility/MajorButton";
const FailSection = () => {
  //   const { currentTrade } = useCurrentTrade();
  const currentTrade = null;
  const { t } = useTranslation("checkout");
  return (
    <div style={{ marginLeft: 24, marginRight: 24 }}>
      <h2>{t("trade-fail")}</h2>
      {currentTrade && (
        <Typography style={{ color: "#918F8D" }}>
          {/* {t("error-reason-code")}：{currentTrade.reason_code} */}
        </Typography>
      )}

      <Typography style={{ paddingBottom: 16, color: "#918F8D" }}>
        {currentTrade && (
          <CheckOutErrorMessage
            currentTrade={currentTrade}
          ></CheckOutErrorMessage>
        )}
      </Typography>
      <Typography style={{ paddingBottom: 16, color: "#918F8D" }}>
        {t("error-supplement")}
      </Typography>
      {/* <Divider ></Divider> */}

      {/* <div
        id="back-to-checkout"
        style={{
          paddingTop: 22,
          width: 300,
          marginLeft: "auto",
          marginRight: "auto",
          paddingBottom: 18,
        }}
      >
        <MajorButton
          style={{ fontSize: 20 }}
          onClick={() => {
            // checkOutCtx.setCheckOutState("filling");
          }}
        >
          {t("back-to-checkout")}
        </MajorButton>
      </div> */}
    </div>
  );
};
export default function CheckOutFailRoute() {
  return (
    <PageContainer>
      <Head>
        <title>Checkout Fail</title>
      </Head>
      <TranslateWrapper ns="checkout">
        {/* <React.Suspense fallback={<div>loading</div>}> */}
        <AuthCheckRedirect>
          <PageContainer>
            <SimpleContainer
              style={{
                // marginTop: isMobileOnly ? 0 : 64,
                // marginBottom: isMobileOnly ? 0 : 48,
                // paddingRight: isMobileOnly ? 6 : 24,
                // paddingLeft: isMobileOnly ? 6 : 24,
                // backgroundColor: "#15171A",
                maxWidth: 710,
              }}
            >
              <FailSection></FailSection>
            </SimpleContainer>
          </PageContainer>
        </AuthCheckRedirect>
        {/* </React.Suspense> */}
      </TranslateWrapper>
    </PageContainer>
    // </TranslateProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({
  params,
  locale,
  // previewData,
  preview,
}) => {
  try {
    // let checkoutTranlstate =
    //   await fetchStoryContent<CheckoutTranslateStoryblok>({
    //     full_slug: "translate/checkout-translate",
    //     locale,
    //   });

    return {
      props: {
        translate: await fetchTranslates(
          ["commontranslate", "checkout-translate"],
          locale
        ),
        // checkoutTranlstate: checkoutTranlstate,
      },
    };
  } catch (e) {
    console.log(e);
  }
};
